module.exports = __webpack_public_path__ + "static/accr-iso-new-353f8253966154e16e3766562348c739.svg";